import { ProjectDataSheet } from "@/components/project/ProjectDataSheet"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_private/projects/$id/data/")({
  component: () => <ProjectDataSheet data-slot="sheet-description" />,
})
